/* Grid density toggle (torch). Each .js-btn carries data-cols (desktop columns)
   and data-cols-mobile (mobile columns). Clicking one writes those onto
   #product-grid (data-cols / data-cols-m), which the CSS uses to re-flow the
   grid, and remembers the choice in localStorage. Both column values come from
   theme-editor settings, so this file has no hard-coded numbers. */
if (!customElements.get('collection-view')) {
  class CollectionView extends HTMLElement {
    constructor() {
      super();
      this.setInitialStates();

      this.addEventListener('click', (e) => {
        // e.target may be the inner <svg>/<rect>; resolve to the button.
        const btnTarget = e.target.closest('.js-btn');
        if (!btnTarget || !this.contains(btnTarget)) return;

        const productGrid = document.querySelector('#product-grid');
        if (!productGrid) return;

        const btnSelected = this.querySelector('.js-btn[disabled]');
        this.updateStates(btnTarget, btnSelected, productGrid);

        if (window.Shopify && Shopify.designMode) return;

        try {
          localStorage.setItem('collection-grid-cols', btnTarget.dataset.cols);
          localStorage.setItem('collection-grid-cols-m', btnTarget.dataset.colsMobile || '');
        } catch (err) {}
      });
    }

    setInitialStates() {
      if (window.Shopify && Shopify.designMode) return;

      let storedCols;
      try {
        storedCols = localStorage.getItem('collection-grid-cols');
      } catch (err) {
        return;
      }
      if (!storedCols) return;

      const productGrid = document.querySelector('#product-grid');
      if (!productGrid || productGrid.dataset.cols === storedCols) return;

      const newBtn = this.querySelector('.js-btn[data-cols="' + storedCols + '"]');
      const btnSelected = this.querySelector('.js-btn[disabled]');
      if (!newBtn) return;

      this.updateStates(newBtn, btnSelected, productGrid);
    }

    updateStates(newBtn, initialBtn, productGrid) {
      if (!newBtn) return;
      if (initialBtn) initialBtn.removeAttribute('disabled');
      newBtn.setAttribute('disabled', 'true');

      productGrid.dataset.cols = newBtn.dataset.cols;
      if (newBtn.dataset.colsMobile) {
        productGrid.dataset.colsM = newBtn.dataset.colsMobile;
      }

      this.updateGridItems();
    }

    // Some themes hide/show a subset of products per row when the count changes
    // (load-more pagination). If that element exists, let it re-evaluate; the
    // pure CSS re-flow works with or without it.
    updateGridItems() {
      const collectionLoadMore = document.querySelector('collection-load-more');
      if (collectionLoadMore && typeof collectionLoadMore.toggleProductsVisibility === 'function') {
        collectionLoadMore.toggleProductsVisibility();
      }
    }
  }

  customElements.define('collection-view', CollectionView);
}
